import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button, InputNumber, Modal, Spin, Popover } from "antd";
import { useParams, useHistory, useLocation } from "react-router-dom";
import { LoadingOutlined, DownOutlined } from "@ant-design/icons";
import { loadStripe } from "@stripe/stripe-js";
import "../../css/pricing.css";
import arrowBlack from "../../images/arrowBlack.svg";
import backIcon from "../../images/drop-arrow.png";
import {
  CardNumberElement,
  CardCvcElement,
  CardExpiryElement,
  AddressElement,
  Elements,
  useStripe,
  useElements,
  CardElement,
  PaymentElement,
} from "@stripe/react-stripe-js";
import "./temp.css";

import {
  createPaymentIntent,
  setPaymentMethodAndCheckout,
  getUpgradePreview,
  upgrade,
} from "../../redux/actions/payment";

import { getUserDetails, setGroupPlan } from "../../redux/actions/user";
import { getPlans } from "../../redux/actions/payment";

import { Switch } from "antd";
const onChange = (checked) => {
  console.log(`switch to ${checked}`);
};

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

const options = {
  // Fully customizable with appearance API.
  appearance: {
    theme: "stripe",
    variables: {
      fontLineHeight: "normal",
      borderRadius: "3px",
      colorPrimary: "#dce0e5",
      colorBackground: "#F6F8FA",
      colorPrimaryText: "#1d262e",
    },
    rules: {
      ".Block": {
        backgroundColor: "var(--colorPrimary)",
        boxShadow: "none",
        padding: "12px",
      },
      ".Input": {
        padding: "12px",
        fontSize: "13px",
        border: "0px",
        width: "100%",
      },
      ".Input:disabled, .Input--invalid:disabled": {
        color: "lightgray",
      },
      ".Tab": {
        padding: "10px 12px 8px 12px",
        border: "none",
      },
      ".Tab:hover": {
        border: "none",
        boxShadow:
          "0px 1px 1px rgba(0, 0, 0, 0.03), 0px 3px 7px rgba(18, 42, 66, 0.04)",
      },
      ".Tab--selected, .Tab--selected:focus, .Tab--selected:hover": {
        border: "none",
        backgroundColor: "#fff",
        boxShadow:
          "0 0 0 1.5px var(--colorPrimaryText), 0px 1px 1px rgba(0, 0, 0, 0.03), 0px 3px 7px rgba(18, 42, 66, 0.04)",
      },
      ".Label": {
        fontWeight: "500",
        fontSize: "13px",
      },
    },
  },
};

const CheckoutForm = (props) => {
  const history = useHistory();
  const user = props.user;
  const stripe = useStripe();
  const elements = useElements();
  const dispatch = useDispatch();
  const [metadata, setMetadata] = useState(null);
  const [succeeded, setSucceeded] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [error, setError] = useState(null);
  const [updateCard, setUpdateCard] = useState(!Boolean(props?.details));
  const [updateAddress, setUpdateAddress] = useState(!Boolean(props?.details));
  const [userDetails, setUserDetails] = useState({
    paymentMethodId: null,
  });

  const [quantity, setQuantity] = useState(1);
  const [minimumQuantity, setMinimumQuantity] = useState(1);
  const [_proration, _setProration] = useState(null);
  const [loadProration, setLoadProration] = useState(false);
  const [showProrationCalculation, setShowProrationCalculation] =
    useState(true);
  const proration = useSelector((state) => state.paymentReducer.proration);

  useEffect(() => {
    setUpdateCard(!Boolean(props?.details));
    setUpdateAddress(!Boolean(props?.details));
  }, [props?.details]);

  useEffect(() => {
    if (props?.groupPlan?.licenseCount) {
      setQuantity(props?.groupPlan.licenseCount + 1);
      setMinimumQuantity(props?.groupPlan.licenseCount + 1);
    }
    getProration();
  }, [props?.groupPlan, props.plan]);

  useEffect(() => {
    _setProration(proration);
    setLoadProration(false);
  }, [proration]);

  const getProration = () => {
    const { plan } = props;
    if (props.plan && props?.groupPlan?.licenseCount) {
      setLoadProration(true);
      dispatch(getUpgradePreview(plan.id, quantity));
    }
  };

  const handleSubmit = async (ev) => {
    ev.preventDefault();
    setProcessing(true);

    if (updateCard && updateAddress) {
      const addressElement = elements.getElement("address");
      const { complete, value } = await addressElement.getValue();

      if (!userDetails.paymentMethodId) {
        const { error, paymentMethod } = await stripe.createPaymentMethod({
          type: "card",
          card: elements.getElement(
            CardCvcElement,
            CardExpiryElement,
            CardNumberElement
          ),
          billing_details: {
            ...value,
            email: user?.email,
          },
        });
        if (!error) {
          dispatch(
            setPaymentMethodAndCheckout({
              ...paymentMethod,
              paymentIntent: props.paymentIntentId,
              plan: props.plan,
              quantity,
            })
          );
        }
      } else {
        dispatch(
          upgrade({
            type: _proration.type,
            planId: props.plan.id,
            quantity,
          })
        );
      }
    } else {
      dispatch(
        upgrade({
          type: _proration.type,
          planId: props.plan.id,
          quantity,
        })
      );
    }
  };

  return (
    <form className="template-flex">
      <div className="checkout-page template-box scrollable">
        <div className="container">
          <div className="tp-title">
            <button
              className="btn btn-default"
              onClick={() => history.push("/pricing")}
            >
              <img
                src={backIcon}
                style={{
                  width: "12px",
                  marginRight: "5px",
                  transform: "rotate(90deg)",
                }}
              />
              <span>Back</span>
            </button>
          </div>
        </div>
        <div className="container">
          <div className="pricing-check">
            <div className="col-md-8 price-col-1">
              <h1 className="chk-title"> Bill Details</h1>

              {updateAddress ? (
                <div className="chk-block">
                  <h5>Sold To Address</h5>

                  <div className="checkout-wrapper">
                    <div>
                      <AddressElement
                        className="addressElement"
                        options={{
                          mode: "billing",
                          defaultValues: {
                            name: user?.name,
                            address: {
                              ...props?.details?.shippingAddress,
                            },
                          },
                          theme: "night",
                          labels: "floating",
                        }}
                      />
                    </div>
                  </div>
                </div>
              ) : (
                <div className="chk-block">
                  <Button
                    style={{ float: "right" }}
                    type="primary"
                    onClick={() => setUpdateAddress(!updateAddress)}
                  >
                    Edit Address
                  </Button>
                  <div>
                    <h5 style={{ fontSize: 16, margin: "20px 0px" }}>
                      {" "}
                      Sold To Address
                    </h5>
                    {props.details &&
                      Object.keys(props?.details?.shippingAddress).map(
                        (item, i) => {
                          return (
                            <div
                              key={i}
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                }}
                              >
                                <p>
                                  <span
                                    style={{
                                      textTransform: "capitalize",
                                      fontWeight: 500,
                                      fontSize: 12,
                                    }}
                                  >
                                    {item.replace("_", " ")}
                                  </span>
                                  :
                                  <span
                                    style={{
                                      textTransform: "capitalize",
                                      fontWeight: "100",
                                      fontSize: 12,
                                      marginLeft: 10,
                                    }}
                                  >
                                    {props?.details?.shippingAddress[item]}
                                  </span>
                                </p>
                              </div>
                            </div>
                          );
                        }
                      )}
                  </div>
                </div>
              )}

              {updateCard ? (
                <div className="chk-block">
                  <h5>Card details</h5>
                  <div className="checkout-wrapper">
                    <div>
                      <div>
                        <label style={{ fontWeight: "500", fontSize: 13 }}>
                          Card Number
                        </label>
                        <CardNumberElement className="cardElement" />
                      </div>

                      <div>
                        <label style={{ fontWeight: "500", fontSize: 13 }}>
                          {" "}
                          Card Expiry Date
                        </label>
                        <CardExpiryElement className="cardElement" />
                      </div>

                      <div>
                        <label style={{ fontWeight: "500", fontSize: 13 }}>
                          {" "}
                          Card Number
                        </label>
                        <CardCvcElement className="cardElement" />
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="chk-block">
                  <Button
                    type="primary"
                    style={{ float: "right" }}
                    onClick={() => setUpdateCard(!updateCard)}
                  >
                    Update Card
                  </Button>
                  <div>
                    <h5 style={{ fontSize: 16, margin: "20px 0px" }}>
                      Card details
                    </h5>
                    {props?.details?.card &&
                      Object.keys(props?.details?.card).map((item, i) => {
                        return (
                          <div
                            key={i}
                            style={{ display: "flex", flexDirection: "column" }}
                          >
                            <div
                              style={{ display: "flex", flexDirection: "row" }}
                            >
                              <p>
                                <span
                                  style={{
                                    textTransform: "capitalize",
                                    fontWeight: 500,
                                    fontSize: 12,
                                  }}
                                >
                                  {item.replace("_", " ")}
                                </span>
                                :
                                <span
                                  style={{
                                    textTransform: "capitalize",
                                    fontWeight: "100",
                                    fontSize: 12,
                                    marginLeft: 10,
                                  }}
                                >
                                  {item == "last4"
                                    ? `****  ****  ****  ${props?.details?.card[item]}`
                                    : `${props?.details?.card[item]}`}
                                </span>
                              </p>
                            </div>
                          </div>
                        );
                      })}
                  </div>
                </div>
              )}
            </div>

            <div className="col-md-4 price-col-2">
              <h5 className="chk-title">Summary</h5>
              <div className="chk-block chk-summery">
                <div className="chk-sm-inner">
                  <div className="chk-qty">
                    <label style={{ fontWeight: "500", fontSize: 13 }}>
                      Users
                    </label>
                    <InputNumber
                      onBlur={(e) => getProration()}
                      onChange={(e) => setQuantity(e)}
                      min={ props.context && props.context == 'a' ? minimumQuantity : 1}
                      value={quantity}
                      style={{ borderRadius: 3, marginLeft: 10 }}
                    />
                  </div>

                  <div className="chk-price-detail">
                    {props && props?.plan && !loadProration ? (
                      <div>
                        <h6 className="chk-plan-type">{props?.plan?.name}</h6>

                        <div>
                          <div className="chk-price">
                            <span>$</span>
                            <h1 style={{ fontSize: 40 }}>
                              {props?.plan?.price * quantity}
                            </h1>
                            <span>/ month</span>
                          </div>

                          {_proration ? (
                            <>
                              <div>
                                {_proration.calculations.map((i, index) => {
                                  return (
                                    <div
                                      key={index}
                                      style={{
                                        display: "flex",
                                        flex: 1,
                                        flexDirection: "row",
                                        justifyContent: "space-between",
                                        margin: "10px 0px",
                                        alignItems: "center",
                                      }}
                                    >
                                      <div
                                        style={{ flex: 0.75, paddingRight: 5 }}
                                      >
                                        <p
                                          style={{
                                            fontSize: 14,
                                            fontWeight: 600,
                                            margin: 0,
                                            textAlign: "left",
                                          }}
                                        >
                                          {index == 0
                                            ? "Prorated adjustements"
                                            : `${i.plan}`}
                                        </p>
                                        <p
                                          style={{
                                            fontSize: 11,
                                            margin: 0,
                                            textAlign: "left",
                                            fontWeight: 100,
                                          }}
                                        >
                                          {i.description}
                                        </p>
                                      </div>
                                      <span
                                        style={{
                                          flex: 0.25,
                                          fontSize: 14,
                                          fontWeight: 600,
                                        }}
                                      >
                                        {i.amount / 100} $
                                      </span>
                                    </div>
                                  );
                                })}

                             

                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                    marginTop: 20,
                                    alignItems: "center",
                                  }}
                                >
                                  <span
                                    style={{ fontSize: 24, fontWeight: 600 }}
                                  >
                                     {_proration.type == "downgrade" ? "Payable next month" : "Due Amount" }
                                  </span>
                                  <span
                                    style={{ fontSize: 24, fontWeight: "bold" }}
                                  >
                                    ${_proration.amount_due / 100}
                                  </span>
                                </div>

                                {_proration.type == "downgrade" ? (
                                  <div
                                    style={{
                                      marginTop: 10,
                                      backgroundColor: "#F2F5F6",
                                      padding: 15,
                                      textAlign: "start",
                                    }}
                                  >
                                    <p
                                      style={{
                                        fontSize: 11,
                                        fontWeight: "100",
                                      }}
                                    >
                                      Since you are downgrading, your current
                                      plan will continue till the term end and
                                      new price would be applicable at the end
                                      of current billing cycle
                                    </p>
                                  </div>
                                ) : null}

                              </div>
                            </>
                          ) : (
                            <div className="chk-price-break">
                              <table>
                                <tbody>
                                  <tr>
                                    <td colSpan={2}>
                                      $ {props?.plan?.price} x 1 month x{" "}
                                      {quantity} users
                                    </td>
                                    <th>$ {props?.plan?.price * quantity}</th>
                                  </tr>
                                  <tr>
                                    <td colSpan={2}>Due Amount</td>
                                    <th>${props?.plan?.price * quantity}</th>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          )}
                        </div>
                      </div>
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          height: 130,
                        }}
                      >
                        <Spin
                          size="large"
                          indicator={
                            <LoadingOutlined style={{ fontSize: 30 }} spin />
                          }
                        />
                      </div>
                    )}
                  </div>

                  <div></div>

                  <Button
                    onClick={handleSubmit}
                    type="primary"
                    disabled={processing || loadProration}
                  >
                    <p> {processing ? "Processing…" : _proration?.type == "downgrade" ? "Proceed" : "Pay" }</p>
                    <span>
                      <img src={arrowBlack} />
                    </span>
                  </Button>

                  <p style={{ fontSize: 12 }}>
                    By placing this order you agree to our{" "}
                    <a>Terms & Conditions </a> and auto-renewal.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

const Checkout = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [clientSecret, setClientSecret] = useState("null");
  const [paymentIntentId, setPaymentIntentId] = useState("null");
  const [plan, setPlan] = useState(null);
  const [context, setContext] = useState(null)
  const [minimumQuantity, setMinimumQuantity] = useState(1);
  const queryParams = useLocation().search;
  const paymentIntent = useSelector(
    (state) => state.paymentReducer.paymentIntent
  );
  const user = useSelector((state) => state.userReducer.user);
  const details = useSelector((state) => state.userReducer.details);
  const plans = useSelector((state) => state.paymentReducer.plans);
  const groupPlan = useSelector((state) => state.userReducer.groupPlan);

  const getPlan = (planId) => {
    return plans.filter((i) => i.id == planId)[0];
  };

  const checkoutResponse = useSelector(
    (state) => state.paymentReducer.checkoutResponse
  );

  useEffect(() => {
    dispatch(getPlans());
  }, []);

  useEffect(() => {
    if (user) {
      dispatch(getUserDetails(user.sub));
    }
  }, [user]);

  useEffect(() => {
    const planId = new URLSearchParams(queryParams).get("p");
    const _context = new URLSearchParams(queryParams).get("c");

    setContext(_context)
    const plan = getPlan(planId);
    setPlan(plan);
  }, [plans]);

  useEffect(() => {
    if (checkoutResponse) {
      Modal.success({
        content: "Payment is successful.",
        afterClose: () => {
          setGroupPlan();
          window.location.href = window.location.origin;
        },
      });
    }
  }, [checkoutResponse]);

  // useEffect(() => {
  //   if (paymentIntent) {
  //     setClientSecret(paymentIntent.clientSecret);
  //     setPaymentIntentId(paymentIntent.id);
  //   }
  // }, [paymentIntent]);

  return (
    <div style={{ marginBottom: 50 }}>
      {clientSecret ? (
        <div>
          <Elements stripe={stripePromise} options={options}>
            <CheckoutForm
              clientSecret={clientSecret}
              paymentIntentId={paymentIntentId}
              user={user}
              plan={plan}
              details={details}
              minimumQuantity={minimumQuantity}
              groupPlan={groupPlan}
              context={context}
            />
          </Elements>
        </div>
      ) : (
        <h3> loading </h3>
      )}
    </div>
  );
};

export default Checkout;
